import React, { Component } from 'react';
import Header from './header';
import Footer from './footer';
import Welcome from './welcome';
import Previewsoa from './previewsoa';
import Submitsoa from './submitsoa';
import { getAgentSOADetails, getClientSOADetails } from '../api/apirequest';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import '../css/style.css';
var Loader = require('react-loader');
const publicIp = require('public-ip');

let agentDetails = [];

class Master extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showWelcomePage: (props.IsAgent === true || props.IsMPA === true) ? false : true,
      showPrvwsoaPage: false,
      showSbtsoaPage: (props.IsAgent === true || props.IsMPA === true) ? true : false,
      show: true,
      agentDetails: [],
      IsAgent: props.IsAgent,
      soaid: props.soaid,
      loaded: false
    }
    // this.getURL();
    //props.soaid !== "" ? this.getClientDetails(props.searchObj) : this.getAgentDetails(props.searchObj);
  }

  async getIP() {
    let ip = await (publicIp.v4());
    // console.log(ip);
    this.setState({
      ip: ip
    });
  }

  async getURL() {
    let searchObj = "";
    let IsAgent = true;
    let soaid = 1;
    if (window.location.search !== "") {
      //searchObj = queryString.parse(window.location.href);
      searchObj = window.location.href;
      //searchObj = "https://www.producermax.com/agent/soa/default.html?agentnpn=11111";
      //searchObj = "https://producermax.com/soa_dev/?lance-hoeltke-12345";
      if (IsAgent === true) {
        this.getAgentDetails(searchObj);
      }
      else {
        this.getClientDetails(searchObj);
      }

      this.setState({
        searchObj: searchObj,
        IsAgent: IsAgent,
        soaid: soaid
      });
    }
    else {
      alert("Please enter a valid link shared by your agent");
      return false
    }
  }

  async getAgentDetails(searchObj) {
    agentDetails = await getAgentSOADetails(searchObj, this.props.config.WebApiUrl);
    if (agentDetails === null) {
      this.setState({
        loaded: true
      });
      alert("Please enter a valid link shared by your agent");
      return false
    } else {
      this.setState({
        agentDetails: agentDetails,
        loaded: true
      });
    }
  }

  async getClientDetails() {
    let clientDetails = await getClientSOADetails(this.props.soaid, this.props.config.WebApiUrl);
    if (clientDetails === null) {
      alert("Please enter a valid link shared by your agent");
      return false
    } else {
      this.setState({
        clientDetails: clientDetails
      });
      //this.getAgentDetails(clientDetails.AgentSOAWebLink, this.props.config.WebApiUrl);
      this.getAgentDetails(clientDetails.AgentSOAWebLink, this.props.config.WebApiUrl);
    }
  }

  getWelcomeResult = () => {
    //console.log("Welcome Success");
    this.setState({
      showWelcomePage: false,
      showPrvwsoaPage: true,
      showSbtsoaPage: false
    });
  }

  getPreviewsoaResult() {
    this.setState({
      showWelcomePage: false,
      showPrvwsoaPage: false,
      showSbtsoaPage: true
    });
  }

  getSubmitsoaResult() {
    this.setState({
      showWelcomePage: true,
      showPrvwsoaPage: false,
      showSbtsoaPage: false
    });
  }

  componentDidMount() {
    this.getIP();
    this.props.soaid !== "" ? this.getClientDetails(this.props.searchObj) : this.getAgentDetails(this.props.searchObj);
  }

  render() {
    return (
      <div>
        <Loader loaded={this.state.loaded}>
          {this.state.agentDetails.length != 0 ? (
            <div>
              <Header
                AgencyLogoServerPath={agentDetails.AgencyLogoServerPath}
                config={this.props.config}
              />
              {this.state.showWelcomePage ?
                <Welcome
                  getResult={this.getWelcomeResult.bind(this)}
                  agentDetails={agentDetails}
                  config={this.props.config}
                />
                : null
              }
              {this.state.showPrvwsoaPage ?
                <Previewsoa
                  getResult={this.getPreviewsoaResult.bind(this)}
                  agentDetails={agentDetails}
                />
                : null
              }
              {this.state.showSbtsoaPage ?
                <Submitsoa
                  getResult={this.getSubmitsoaResult.bind(this)}
                  AgentSOAWebLink={agentDetails.AgentSOAWebLink}
                  agentDetails={agentDetails}
                  AgentSignFile={agentDetails.AgentSignFile}
                  ip={this.state.ip}
                  config={this.props.config}
                  clientDetails={this.state.clientDetails}
                  IsAgent={this.props.IsAgent}
                  soaid={this.props.soaid}
                />
                : null
              }
              <Footer config={this.props.config} />
            </div>) : null}
        </Loader>
      </div>
    );
  }
}

export default Master;